var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHackbio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 520,
    viewBox: "0 0 520 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3698_1881)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 256,
    r: 250,
    fill: "#27AE60"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.078 168.5V343H217.078V268.75H142.328V343H107.328V168.5H142.328V240.25H217.078V168.5H252.078ZM385.527 253.5C395.361 255.333 403.444 260.25 409.777 268.25C416.111 276.25 419.277 285.417 419.277 295.75C419.277 305.083 416.944 313.333 412.277 320.5C407.777 327.5 401.194 333 392.527 337C383.861 341 373.611 343 361.777 343H286.527V168.5H358.527C370.361 168.5 380.527 170.417 389.027 174.25C397.694 178.083 404.194 183.417 408.527 190.25C413.027 197.083 415.277 204.833 415.277 213.5C415.277 223.667 412.527 232.167 407.027 239C401.694 245.833 394.527 250.667 385.527 253.5ZM321.527 240.5H353.527C361.861 240.5 368.277 238.667 372.777 235C377.277 231.167 379.527 225.75 379.527 218.75C379.527 211.75 377.277 206.333 372.777 202.5C368.277 198.667 361.861 196.75 353.527 196.75H321.527V240.5ZM356.777 314.5C365.277 314.5 371.861 312.5 376.527 308.5C381.361 304.5 383.777 298.833 383.777 291.5C383.777 284 381.277 278.167 376.277 274C371.277 269.667 364.527 267.5 356.027 267.5H321.527V314.5H356.777Z",
    fill: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3698_1881",
    x: 0,
    y: 0,
    width: 520,
    height: 520,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3698_1881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3698_1881",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackbio);
export default __webpack_public_path__ + "static/media/hackbio.a74b4a48a6d306616be7430a67f0af07.svg";
export { ForwardRef as ReactComponent };